import { parse as parseUrl } from 'url'
import { Environment } from './environment'

const uiConfig = global.__CONFIG__
if (uiConfig.env) uiConfig.env = new Environment(uiConfig.env)
if (uiConfig.origin) uiConfig.originUrl = parseUrl(uiConfig.origin)

export default uiConfig
